<app-loader 
  [size]="loaderSize"
  [message]="loaderMessage"
  [color]="loaderColor"
></app-loader>
